import { FlattenedItem, TreeItems } from './builder'

export function flatten(
  items: TreeItems,
  parentId: string | null = null,
  parentTitle: string | null = null,
  parentType: string | null = null,
  depth = 0
): FlattenedItem[] {
  if (typeof items === 'undefined') return []
  return items?.reduce<FlattenedItem[]>((acc, item, index) => {
    return [
      ...acc,
      { ...item, parentId, parentTitle, parentType, depth, index },
      ...flatten(item?.children, item?.id, item?.title, item?.compId, depth + 1),
    ]
  }, [])
}

export function getAncestors(items: FlattenedItem[], itemId: string): FlattenedItem[] {
  const item = items.find((i) => i.id === itemId)
  const ancestors: FlattenedItem[] = []
  if (item) {
    if (item.parentId) {
      const currentParent = items.find((i) => i.id === item.parentId)
      if (currentParent) {
        ancestors.push(currentParent)
        if (currentParent.parentId) {
          ancestors.push(...getAncestors(items, currentParent.id))
        }
      }
    }
  }

  return ancestors
}
